export const encyclopediaFr = {
  // Partagé
  'encyclopedia.lockAria': 'Verrouillé — déverrouille pour lire',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'L\'Encyclopédie',
  'encyclopedia.page.seoDescription':
    'Parcourez le grimoire vivant de Grymwyrd — monstres, sorts, espèces, objets, lieux et bien plus.',
  'encyclopedia.page.heading': 'L\'Encyclopédie',
  'encyclopedia.page.subtitle': 'Le grimoire vivant de chaque horreur, sort et légende de Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Chercher {plural}…',
  'encyclopedia.page.searchAria': 'Chercher {plural}',
  'encyclopedia.page.clearSearch': 'Effacer la recherche',
  'encyclopedia.page.systemNotLivePrefix': 'Le Voile ne s\'est pas encore déchiré pour',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Aucun savoir lié à ce rite n\'a transpercé — son grimoire attend au-delà des ténèbres.',
  'encyclopedia.page.returnToAllSystems': 'Revenir à tous les systèmes',
  'encyclopedia.page.settingNotLivePrefix': 'Les terres de',
  'encyclopedia.page.settingNotLiveSuffix':
    ' se font encore cartographier — ses entrées ne sont pas encore liées au monde. Jusqu\'à ce que les cartographes terminent, rien ne répond ici.',
  'encyclopedia.page.returnToAllRealms': 'Revenir à tous les royaumes',
  'encyclopedia.page.filteringBy': 'Filtre par',
  'encyclopedia.page.filterSystem': 'système « {label} »',
  'encyclopedia.page.filterCanon': 'couche canon « {label} »',
  'encyclopedia.page.filterSetting': 'monde « {label} »',
  'encyclopedia.page.canonNote': 'La couche canon s\'applique une fois les entités marquées dans l\'API (voir _docs/13). ',
  'encyclopedia.page.clear': 'Effacer',
  'encyclopedia.page.hide': 'Masquer',
  'encyclopedia.page.filter': 'Filtrer',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Déverrouille {name} (contenu Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Afficher l\'entrée {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Pagination ({position})',
  'encyclopedia.grid.prev': 'Précédent',
  'encyclopedia.grid.next': 'Suivant',
  'encyclopedia.grid.pageOf': 'Page {page} sur {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} résultats',
  'encyclopedia.grid.scrying': 'Scrutation des archives…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Trier en ordre décroissant',
  'encyclopedia.grid.sortAscAria': 'Trier en ordre croissant',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Mode d\'affichage',
  'encyclopedia.grid.gridViewAria': 'Affichage en grille',
  'encyclopedia.grid.listViewAria': 'Affichage en liste',
  'encyclopedia.grid.jumpToLetterAria': 'Aller à la lettre',
  'encyclopedia.grid.all': 'Tous',
  'encyclopedia.grid.letterSymbolAria': 'Entrées commençant par un chiffre ou un symbole',
  'encyclopedia.grid.letterAria': 'Entrées commençant par {letter}',
  'encyclopedia.grid.emptyTitle': 'Les Archives Sont Silencieuses',
  'encyclopedia.grid.emptyForLetter': 'Aucun {plural} ne porte un nom commençant par « {letter} ».',
  'encyclopedia.grid.emptyAll': 'Aucun {plural} ne répond à ton appel.',
  'encyclopedia.grid.turningPages': 'Feuilletage…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (aucune illustration)',
  'encyclopedia.entityImage.noVision': 'Aucune Vision',

  // FacetSidebar
  'encyclopedia.facets.all': 'Tous',
  'encyclopedia.facets.soon': 'Bientôt',
  'encyclopedia.facets.navAria': 'Filtres de type d\'entité',
  'encyclopedia.facets.clearAll': 'Effacer tous les filtres',
  'encyclopedia.facets.lorebook': 'Grimoire',
  'encyclopedia.facets.gameSystem': 'Système de Jeu',
  'encyclopedia.facets.canonLayer': 'Couche Canon',
  'encyclopedia.facets.setting': 'Monde',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Scruter le Voile',
  'encyclopedia.globalSearch.placeholder': 'Chercher monstres, sorts, lieux, légendes…',
  'encyclopedia.globalSearch.queryAria': 'Requête de recherche',
  'encyclopedia.globalSearch.loading': 'Scrutation…',
  'encyclopedia.globalSearch.empty': 'Rien ne s\'agite dans les ténèbres pour « {q} ».',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Contenu Grymwyrd — déverrouille pour lire',
  'encyclopedia.lockBadge.label': 'Verrouillé',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Contenu verrouillé',
  'encyclopedia.lockedGate.defaultTitle': 'Ce savoir est scellé',
  'encyclopedia.lockedGate.body':
    'Le bestiaire, les sorts et les légendes de Grymwyrd sont liés au Cataclysme de Grymwyrd. Le canon ouvert SRD reste gratuit — mais pour marcher dans le crépuscule éternel lui-même, réclame le livre.',
  'encyclopedia.lockedGate.unlockCta': 'Déverrouille Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Déjà un backer ? Se connecter',
  'encyclopedia.lockedGate.backerNote':
    'Les backers qui ont soutenu Grymwyrd possèdent déjà ceci — connecte-toi pour le déverrouiller sur ton compte.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — résultat {total}',
  'encyclopedia.table.noRowMatched': 'Aucune ligne ne correspondait à {total}.',
  'encyclopedia.table.loading': 'Déploiement de la table…',
  'encyclopedia.table.error': 'Cette table n\'a pas pu être tracée.',
  'encyclopedia.table.roll': 'Lancer {formula}',
  'encyclopedia.table.lastRoll': 'Dernier lancer : {value}',
  'encyclopedia.table.noMatchingRow': ' · aucune ligne correspondante',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Entrée',
  'encyclopedia.detail.addedToCampaign': 'Ajouté à ta campagne.',
  'encyclopedia.detail.addError': 'Impossible de rejoindre la chambre forte de la campagne. Réessaie plus tard.',
  'encyclopedia.detail.unknownType': 'Type d\'entrée inconnu.',
  'encyclopedia.detail.seoDescription': '{name} — {label} dans l\'Encyclopédie de Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Fil d\'Ariane',
  'encyclopedia.detail.breadcrumbRoot': 'Encyclopédie',
  'encyclopedia.detail.sourceVersionAria': 'Version de la source',
  'encyclopedia.detail.versionConsolidated': 'Consolidée',
  'encyclopedia.detail.versionBook': 'Livre Spécifique',
  'encyclopedia.detail.removeBookmarkAria': 'Retirer le signet',
  'encyclopedia.detail.addBookmarkAria': 'Ajouter un signet',
  'encyclopedia.detail.bookmarked': 'Avec signet',
  'encyclopedia.detail.bookmark': 'Signet',
  'encyclopedia.detail.addToCampaign': 'Ajouter à la Campagne',
  'encyclopedia.detail.sealedTitle': '{name} est scellée',
  'encyclopedia.detail.bookVariantNote':
    'Affichage du dossier consolidé ; le texte de la variante par livre s\'affichera ici une fois que les éditions de livres seront liées.',
  'encyclopedia.detail.tablistAria': 'Sections d\'entrée',
  'encyclopedia.detail.tab.lore': 'Légende',
  'encyclopedia.detail.tab.stats': 'Caractéristiques',
  'encyclopedia.detail.tab.gallery': 'Galerie',
  'encyclopedia.detail.tab.relations': 'Relations',
  'encyclopedia.detail.tab.discussions': 'Discussions',
  'encyclopedia.detail.tab.claims': 'Revendications de Joueur',
  'encyclopedia.detail.loading': 'Réveil de l\'entrée…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Exhumation des légendes…',
  'encyclopedia.lore.empty': 'Les histoires de cette entrée restent non écrites.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Lecture des runes…',
  'encyclopedia.stats.empty': 'Aucune mécanique n\'est enregistrée pour cette entrée.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Développement des visions…',
  'encyclopedia.gallery.emptyTitle': 'Aucune Vision Encore',
  'encyclopedia.gallery.emptyBody': 'Aucune illustration n\'a été liée à cette entrée. Contribue une dans la Chambre Forte.',
  'encyclopedia.gallery.artworkAlt': 'Illustration d\'entité',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Rassemblement des murmures…',
  'encyclopedia.discussions.emptyTitle': 'Silence dans les Salles',
  'encyclopedia.discussions.emptyBody': 'Sois le premier à discuter de cette entrée avec tes compagnons voyageurs.',
  'encyclopedia.discussions.startCta': 'Commencer une Discussion',
  'encyclopedia.discussions.untitledThread': 'Fil sans titre',
  'encyclopedia.discussions.byAuthor': 'par {author}',
  'encyclopedia.discussions.replyCount': '{count} réponses',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Ta revendication a été enregistrée pour examen.',
  'encyclopedia.claims.recordError': 'Les scribes n\'ont pas pu enregistrer ta revendication. Réessaie plus tard.',
  'encyclopedia.claims.loading': 'Consultation du canon…',
  'encyclopedia.claims.emptyTitle': 'Aucune Revendication de Joueur Encore',
  'encyclopedia.claims.emptyBody': 'Aucun voyageur n\'a encore tissé sa légende dans cette entrée.',
  'encyclopedia.claims.claimCta': 'Revendiquer ceci',
  'encyclopedia.claims.signInCta': 'Connecte-toi pour faire une revendication',
  'encyclopedia.claims.untitledClaim': 'Revendication sans titre',
  'encyclopedia.claims.byAuthor': 'par {author}',
  'encyclopedia.claims.addCta': 'Ajoute ta revendication',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Cette Entrée',
  'encyclopedia.relations.relationLabel': 'Relation {index}',
  'encyclopedia.relations.kindredLabel': 'Semblable {index}',
  'encyclopedia.relations.loading': 'Traçage des fils du destin…',
  'encyclopedia.relations.hintIntro': 'Clique sur un nœud pour voyager vers cette entrée. Les fils affichés sont',
  'encyclopedia.relations.hintCanonical': ' des relations canoniques.',
  'encyclopedia.relations.hintKindred': ' des semblables du même type.',
}
